import { IntlShape } from "react-intl";
import { ITextField } from "cayo.ui";
import { HourlySchedule } from "@cayo/shared/api/types/cayo-graph";
import { IFormField } from "@cayo/shared/api/types/schema";
import messages from "./messages";
import scheduleRegexes from "./regexes";
import { nameofFactory } from "@cayo/shared/utils/object";
import { regexs } from "../../utils/regexs";
import { formComponentTypes } from "../Form/renderers/form-renderers";

const hourlyNames = nameofFactory<HourlySchedule>();

const hourlyForm = (intl: IntlShape, schedule?: HourlySchedule) => {
  return {
    title: intl.formatMessage(messages.hourly),
    items: [
      {
        type: "number" as formComponentTypes,
        label: intl.formatMessage(messages.repeatEvery),
        autoFocus: true,
        required: true,
        disabled: schedule?.readОnly,
        pattern: regexs.positiveInt32Regex.source,
        name: hourlyNames("period"),
        value: schedule?.period?.toString() || "1",
        tip: intl.formatMessage(messages.hoursTip),
      } as ITextField,
      {
        type: "number" as formComponentTypes,
        label: intl.formatMessage(messages.onMinute),
        required: true,
        disabled: schedule?.readОnly,
        pattern: scheduleRegexes.minutesRange.source,
        name: hourlyNames("minute"),
        value: schedule?.minute?.toString() || "0",
        tip: intl.formatMessage(messages.hoursMinutesTip),
      } as ITextField,
    ] as IFormField[],
  };
};

export default hourlyForm;
